const schType = [
  { value: 0, text: '០.ជ្រើសរើស' },
  { value: 1, text: '១.អនុវិទ្យាល័យ' },
  { value: 2, text: '២.វិទ្យាល័យដែលមានតែថ្នាក់មធ្យមសិក្សាទុតិយភូមិ' },
  { value: 3, text: '៣.វិទ្យាល័យដែលមានថ្នាក់មធ្យមសិក្សាបឋមភូមិ និងទុតិយភូមិ' }
]
const schRun = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.សាលារៀនចំណេះទូទៅ' },
  { value: 2, text: '២.សាលារៀនជំនាន់ថ្មី' }, { value: 3, text: '៣.សាលារៀនចំណេះទូទៅនិងច្ចេកទេស' },
  { value: 4, text: '៤.សាលារៀនធនធាន' }, { value: 5, text: '៥.សាលារៀនអប់រំពិសេស' }
]
const schCFS = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.កម្រិតមូលដ្ឋាន' }, { value: 2, text: '២.កម្រិតមធ្យម' },
  { value: 3, text: '៣.កម្រិតអភិវឌ្ឍន៍' }, { value: 4, text: '៤.មិនមានការកំណត់' }
]
const yesNo = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មែន' }, { value: 2, text: '២.មិនមែន' }
]
const ageLow = ['១២', '១៣', '១៤', '១៥', '១៦', '១៧', '១៨', '១៩+', 'សរុប']
const ageHigh = ['១៥', '១៦', '១៧', '១៨', '១៩', '២០', '២១+', 'សរុប']
const ethLow = ['សិស្ស (អាយុ ១២)', 'សិស្ស (អាយុ១២-១៤)', 'សិស្ស (អាយុ ១៥+)', 'គ្រូបង្រៀន', 'គ្រូមិនបង្រៀន']
const ethHig = ['សិស្ស (អាយុ ១៥)', 'សិស្ស (អាយុ ១៥-១៧)', 'សិស្ស (អាយុ ១៨+)', 'គ្រូបង្រៀន', 'គ្រូមិនបង្រៀន']
const lowLevel = ['ថ្នាក់ទី ៧', 'ថ្នាក់ទី ៨', 'ថ្នាក់ទី ៩', 'សរុបសិស្សមធ្យមសិក្សាបឋមភូមិ']
const highLevel = ['ថ្នាក់ទី ១០', 'ថ្នាក់ទី ១១', 'ថ្នាក់ទី ១២', 'សរុបសិស្សមធ្យមសិក្សាទុតិយភូមិ']
const secLevel = ['ថ្នាក់ទី ៧', 'ថ្នាក់ទី ៨', 'ថ្នាក់ទី ៩', 'ថ្នាក់ទី ១០', 'ថ្នាក់ទី ១១', 'ថ្នាក់ទី ១២', 'សរុប']

const b4 = ['លេខាធិការ', 'បណ្ណារក្ស (បណ្ណាល័យស្ដង់ដា)', 'គ្រូទទួលបន្ទុកកីឡា', 'គ្រូទទួលបន្ទុកបច្ចេកវិទ្យាព័ត៌មានវិទ្យា ICT',
  'គ្រូទទួលបន្ទុកគណនេយ្យ និងបេឡា', 'គ្រូទទួលបន្ទុកបន្ទប់ពិសោធន៍', 'គ្រូទទួលបន្ទុកការងារយុវជន', 'គ្រូបង្រៀនអប់រំបំណិនជីវិត',
  'គ្រូទទួលបន្ទុកការងារសុខភាពសិក្សា', 'បុគ្គលិកបង្រៀនដែលមានវិធីសាស្ត្រដាក់ពិន័យសិស្សតាមបែបវិជ្ជមាន']

const d2 = ['ចំនួនសិស្សដើមឆ្នាំសិក្សា', 'ចំនួនសិស្សចុងឆ្នាំសិក្សា', 'សិស្សផ្ទេរមកពីសាលារៀនផ្សេង',
  'សិស្សផ្ទេរចេញទៅសាលារៀនផ្សេង', 'ចំនួនសិស្សត្រូវបានឡើងថ្នាក់ និងជាប់សញ្ញាបត្រ', 'ចំនួនសិស្សអាហារូបករណ៍សិក្សាឆ្នាំថ្មី']

const e2 = ['ចំនួនសិស្សបានចូលរៀនឡើងវិញ', 'ចំនួនសិស្សក្នុងកម្មវិធីសមមូល']
const c4 = ['គ្រូបង្រៀននៅថ្នាក់មធ្យមសិក្សាបឋមភូមិ', 'គ្រូបង្រៀននៅថ្នាក់មធ្យមសិក្សាទុតិយភូមិ',
  'គ្រូបង្រៀនទាំងពីរភូមិសិក្សា', 'គ្រូទទួលបន្ទុកថ្នាក់មធ្យមសិក្សាបឋមភូមិ', 'គ្រូទទួលបន្ទុកថ្នាក់មធ្យមសិក្សាទុតិយភូមិ']
const c4col = ['≤ ១៤ ម៉ោង', '១៥ ម៉ោង', '១៦ ម៉ោង', '១៧ ម៉ោង', '≥ ១៨ ម៉ោង', 'សរុប']
const e4 = ['ភាសាខ្មែរ', 'គណិតវិទ្យា', 'ភូមិវិទ្យា', 'ប្រវត្តិវិទ្យា', 'រូបវិទ្យា', 'គីមីវិទ្យា', 'ជីវវិទ្យា', 'ផែនដីវិទ្យា', 'សីលធម៌/ពលរដ្ឋវិជ្ជា',
  'សេដ្ឋកិច្ច', 'អប់រំសុខភាព', 'ភាសាបារាំង', 'ភាសាអង់គ្លេស', 'បច្ចេកវិជ្ជា ICT', 'បំណិនជីវិតតាមមូលដ្ឋាន', 'សរុប']
const stulowOnOff = [
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
const stuuppOnOff = [
  [1, 1, 0, 0, 1, 1, 0, 0,  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0,  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,  1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
/** Configuration of UI Page Text */
const secUIText = [
  ['១. អត្តសញ្ញាណ <p><br>និងព័ត៌មានសាវតា</p>', '<b>១.(ក) នាយក/នាយិកាអនុវិទ្យាល័យ/វិទ្យាល័យ</b>', '<b>១.(ខ) អនវិទ្យាល័យ/វិទ្យាល័យ</b>', '<b>១.(គ) នាយករងអនុវិទ្យាល័យ/វិទ្យាល័យ</b>'],
  ['២. សិស្ស', '<b>២.(ក១) សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ក្នុងឆ្នាំសិក្សា</b>', '<b>២.(ក១) សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ក្នុងឆ្នាំសិក្សា</b>', '<b>២.(ក២) សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ក្នុងឆ្នាំសិក្សា </b>',
    '<b>២. (ខ) សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់</b>',
    '<b>២. (គ) សិស្សតាមក្រុមអាយុ និងគ្រូ (ជនជាតិដើមភាគិច)</b>', '២.(ឃ) សិស្សមធ្យមសិក្សា តាមកម្រិតថ្នាក់ ឆ្នាំសិក្សា',
    '២. (ង) ចំនួនសិស្ស និងលទ្ធផលប្រឡងក្នុងឆ្នាំសិក្សា', '២. (ច) ចំនួនសិស្សចូលរៀនឡើងវិញ(សិស្ស បោះបង់)',
    '២. (ឆ) លទ្ធផលសិក្សា របស់សិស្សក្នុងឆ្នាំសិក្សា'
  ],
  [
    '៣. បន្ទប់រៀន <p><br>និងថ្នាក់រៀន</p>', '<b>៣. (ក) បន្ទប់រៀន</b>', '<b>៣. (ខ១) ចំនួនថ្នាក់រៀននិង បន្ទប់រៀន</b>','<b>៣. (ខ២) ចំនួនថ្នាក់រៀននិង បន្ទប់រៀន(សម្រាប់ថ្នាក់វិជ្ជាជីវៈ)</b>'
  ],
  [
    '៤. បុគ្គលិកបង្រៀន <p><br>និងបុគ្គលិកមិនបង្រៀន</p>', '៤. (ក) ចំនួនបុគ្គលិកអប់រំតាមប្រភេទក្របខ័ណ្ឌ (សណន លេខ ២៥៦)', '៤. (ខ) ចំនួនបុគ្គលិកបង្រៀន/មិនបង្រៀនក្របខ័ណ្ឌទទួលមុខងារបន្ថែម', 
    '៤. (គ) ចំនួនគ្រូបង្រៀន និងគ្រូកិច្ចព្រមព្រៀងការងារ តាមកម្រិតថ្នាក់','៤.(ឃ) ចំនួនបុគ្គលិកបង្រៀនតាមម៉ោងក្នុង ១សប្ដាហ៍',
    '៤. (ង) កម្រិតវប្បធម៌របស់បុគ្គលិកក្របខ័ណ្ឌ និងវគ្គបណ្ដុះបណ្ដាលគរុកោសល្យ', '៤.(ច) ចំនួនបុគ្គលិកក្របខ័ណ្ឌកំពុងបង្រៀនតាមមុខវិជ្ជា និងជំនាញ'
  ],
  ['៥. អគារ និងបរិក្ខារ', '៥. (ក) ផ្ទៃដីសាលារៀន', '៥. (ខ) អំពីសំណង់', '៥. (គ) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ',
    '៥(ឃ).កន្លែងលាងដៃ', '៥. (ង) បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ច).ប្រភពទឹកសម្រាប់ប្រើប្រាស់',
    '៥(ឆ).សម្ភារបរិក្ខា', '៥. (ជ) សម្ភារកីឡា',
    '៥. អគារ និងបរិក្ខារ', '៥.(ក).ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ', '៥.(ខ).ចំនួនបរិក្ខារ', '៥.(គ).ផ្ទៃដីសាលារៀន',
    '៥(ឃ).កន្លែងលាងដៃ', '៥.(ង).បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ច).ប្រភពទឹកសម្រាប់ប្រើប្រាស់',
    '៥.(ឆ).សម្ភារបរិក្ខារ', '៥.(ជ).ខ្សែសេវា អុីនធើណេតសម្រាប់សាលារៀន', '៥(ឈ).សម្ភារកីឡា',
    '៥.(ញ).អគារអន្តេវាសិកដ្ឋាន (សម្រាប់បុគ្គលិកអប់រំ និងសិស្ស)', '៥.(ដ).អគារអ៊ីនធឺណិតសហគមន៍ ដែលស្ថិតក្នុងបរិវេនសាលារៀន'
  ],
  ['៦. ការចូលរួមរបស់សហគមន៍', '៦. (ក) គណៈកម្មការគ្រប់គ្រងសាលារៀន', '៦. (ខ) ហិរញ្ញប្បទានក្នុងឆ្នាំ'],
  ['៧.  ការចែកចាយថ្នាំព្រូន', '៧.  ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា'],
  ['៨. ស្ថានភាពទឹកស្អាត និង<p><br>អនាម័យតាមសាលារៀន'],
  [
    '៩. ទិន្នន័យស្តីអំពីការបម្រែ<p><br>បម្រួលអាកាសធាតុ',
    '១.ចំនួនសិស្សមានបញ្ហាសុខភាព ដែលពាក់ព័ន្ធព្រឹត្តិការណ៍នៃគ្រោះមហន្តរាយធម្មជាតិ ក្នុងឆ្នាំសិក្សា',
    '២.ប្រអប់សង្រ្គោះបឋមរបស់សាលារៀន',
    '៣.មូលហេតុបិទសាលារៀន និងចំនួនថ្ងៃបិទសាលារៀនដែលមិនបានគ្រោងទុក',
    '៤.ហេដ្ឋារចនាសម្ព័ន្ធសាលារៀនដែលត្រូវខូចខាត ឬបាត់បង់ដោយសារគ្រោះធម្មជាតិ',
    '៥.ការគ្រប់គ្រងគ្រោះមហន្តរាយ និងផែនការកាត់បន្ថយហានិភ័យ',
    '៦.ចំនួនបន្ទប់រៀនដែលមានកង្ហារ ឬម៉ាស៊ីនត្រជាក់',
    '៧.ចំនួនថ្ងៃដែលសាលារៀនជួប្រទះនឹង៖ ការខ្វះអគ្គីសនី ការខ្វះទឹកស្អាត និងបង្គន់ប្រើប្រាស់មិនកើត ដោយសារគ្រោះមហន្តរាយ',
    '៨.ចំនួនសិស្សដែលអវត្តមានក្នុងឆ្នាំសិក្សា ពី២០ថ្ងៃដល់៤០ថ្ងៃ និងលើស៤០ថ្ងៃ (កុំរាប់សិស្សពីរដង)៖',
    '៩.ការរៀនសូត្រជម្រើសផ្សេងទៀត (Alternative Education) ក្នុងពេលដែលសាលារៀនត្រូវបិទ',
    '១០.ចំនួនសម្ភារសិក្សាដែលត្រូវបានខូចខាត ឬត្រូវបានបំផ្លាញ ដោយសារគ្រោះមហន្តរាយ (សៀវភៅគ្រូ និងសៀវភៅសិស្ស)',
    '១១.ការគ្រប់គ្រងកាកសំណល់នៅសាលារៀន',
    '១២.ហិរញ្ញប្បទានរបស់សាលារៀន (សម្រាប់ផលប៉ះពាល់ដោយសារបម្រែបម្រួលអាកាសធាតុ)'
  ]
]
export {
  schType, schRun, schCFS, yesNo,
  ageLow, ageHigh, lowLevel, ethLow, ethHig,
  highLevel, secLevel, b4, d2, e2, c4, c4col, e4,
  stulowOnOff, stuuppOnOff,
  secUIText
}
